export default "__VITE_ASSET__027714ef__"